import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    '& .MuiListItem-container':{
        border: '1px solid #D2D2D8',
        padding: 5,
        width: '90%',
        marginBottom: 5,
    },
    '& .MuiListItem-root':{
        paddingTop:0,
        paddingBottom:0,
    },
    '& .MuiTypography-root':{
        fontSize:12
    },
    
  },
  personIcon: {
    width: 48,
    height: 48,
    padding:0,
    color:'#99E79D'
  },
  personIconDisabled: {
    width: 48,
    height: 48,
    padding:0,
    color:'#bababa'
  },
  icon: {
        '&:hover': {
            color: '#63D764'
        },
    },
}));

export default function FolderList(props) {
  const classes = useStyles();

  const handleUserClick = (userid) => {
    props.handleClick(userid);
}

  return (
    <List className={classes.root}>
        {props.rows.map((item, i) =>
            <ListItem className={classes.listItem} key={i}>
                <ListItemAvatar>
                    {item.status === 'active'? <AccountCircleIcon className={classes.personIcon}/> : <AccountCircleIcon className={classes.personIconDisabled}/>}
                    
                </ListItemAvatar>
                <ListItemText primary={item.username} secondary={item.email} />
                <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="edit" onClick={() => {handleUserClick(item.userid)}}>
                        <EditIcon className={classes.icon} />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        )}
    </List>
  );
}